import { sendImportFromTextEvent } from '../index';
import { EventAdapter } from './EventAdapter';

interface ImportFromTextEventAdapterParams {
  numQuestions: number;
  promptLength: number;
  promptVersion: string;
  version: string;
  responseMilliseconds: number;
  promptTokens: number;
  completionTokens: number;
  totalTokens: number;
}

export class ImportFromTextEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendImportFromTextEvent;
  protected intercomEventKey = 'ai_import_from_text';

  constructor({
    numQuestions,
    promptLength,
    promptVersion,
    version,
    responseMilliseconds,
    promptTokens,
    completionTokens,
    totalTokens,
  }: ImportFromTextEventAdapterParams) {
    super();

    try {
      this.eventData = {
        num_questions: numQuestions,
        prompt_length: promptLength,
        prompt_version: promptVersion,
        version: version,
        response_milliseconds: responseMilliseconds,
        prompt_tokens: promptTokens,
        completion_tokens: completionTokens,
        total_tokens: totalTokens,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
